module.exports = __webpack_public_path__ + "famous.svg?e3b5d2d24ae4af8099318ddf26cedeca";